/* =========================================================
   PawHoodly — bundle.js
   Bundle / quantity selector with one variant picker per item.
   Adds every selected variant to the native Shopify cart, then
   applies the tier's discount code so the bundle total is exact.
   ========================================================= */
(function () {
  'use strict';

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function initBundle(bundle) {
    if (bundle.dataset.bundleReady === 'true') return;
    bundle.dataset.bundleReady = 'true';

    var dataEl = $('[data-bundle-variants]', bundle);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var tiers = $$('[data-bundle-tier]', bundle);
    var errorEl = $('[data-bundle-error]', bundle);
    var rootUrl = bundle.getAttribute('data-root-url') || '/';
    var destination = bundle.getAttribute('data-destination') || 'cart';
    var soldOutSuffix = bundle.getAttribute('data-soldout-suffix') || 'sold out';

    function activeTier() {
      return tiers.filter(function (tier) {
        return tier.classList.contains('is-selected');
      })[0] || tiers[0];
    }

    function matchVariant(values) {
      return variants.filter(function (variant) {
        return variant.options.every(function (option, index) {
          return option === values[index];
        });
      })[0];
    }

    function rowValues(row) {
      var values = [];
      $$('[data-bundle-select]', row).forEach(function (select) {
        values[parseInt(select.getAttribute('data-option-position'), 10) - 1] = select.value;
      });
      return values;
    }

    function markAvailability(row) {
      var selects = $$('[data-bundle-select]', row);
      var current = rowValues(row);

      selects.forEach(function (select) {
        var position = parseInt(select.getAttribute('data-option-position'), 10) - 1;

        $$('option', select).forEach(function (option) {
          var candidate = current.slice();
          candidate[position] = option.value;
          var variant = matchVariant(candidate);
          var sellable = !!variant && variant.available;

          option.disabled = !sellable;
          var base = option.getAttribute('data-label') || option.textContent;
          option.setAttribute('data-label', base);
          option.textContent = sellable ? base : base + ' — ' + soldOutSuffix;
        });
      });
    }

    function selectedItems() {
      var tier = activeTier();
      if (!tier) return null;

      var rows = $$('[data-bundle-item]', tier);
      var counts = {};
      var order = [];
      var ok = true;

      rows.forEach(function (row) {
        var variant = matchVariant(rowValues(row));
        if (!variant || !variant.available) {
          ok = false;
          return;
        }
        if (!counts[variant.id]) {
          counts[variant.id] = 0;
          order.push(variant.id);
        }
        counts[variant.id] += 1;
      });

      if (!ok) return null;

      var items = order.map(function (id) {
        return { id: id, quantity: counts[id] };
      });

      var total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      return total === rows.length ? items : null;
    }

    function selectTier(tier) {
      tiers.forEach(function (candidate) {
        var isSelected = candidate === tier;
        candidate.classList.toggle('is-selected', isSelected);
        var input = $('.bundle__radio-input', candidate);
        if (input) input.checked = isSelected;
      });

      $$('[data-bundle-item]', tier).forEach(markAvailability);

      var total = tier.getAttribute('data-total');
      if (total) {
        $$('[data-bundle-total]').forEach(function (element) {
          element.textContent = total;
        });
      }

      if (errorEl) errorEl.hidden = true;
    }

    tiers.forEach(function (tier) {
      var input = $('.bundle__radio-input', tier);
      if (input) {
        input.addEventListener('change', function () {
          if (input.checked) selectTier(tier);
        });
      }

      $$('[data-bundle-select]', tier).forEach(function (select) {
        select.addEventListener('change', function () {
          var row = select.closest('[data-bundle-item]');
          if (row) markAvailability(row);
          if (errorEl) errorEl.hidden = true;
        });
      });
    });

    function addToCart(button) {
      var tier = activeTier();
      var items = selectedItems();

      if (!items) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = bundle.getAttribute('data-unavailable-text') ||
            'Please choose an available option for each item.';
        }
        return;
      }

      var originalText = button.textContent;
      button.setAttribute('aria-busy', 'true');
      button.textContent = bundle.getAttribute('data-adding-text') || 'Adding…';

      fetch(rootUrl.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) {
              throw new Error(data.description || data.message || ('Cart error ' + response.status));
            }
            return data;
          });
        })
        .then(function () {
          var target = destination === 'checkout' ? '/checkout' : '/cart';
          var code = tier ? tier.getAttribute('data-code') : '';
          var base = rootUrl.replace(/\/$/, '');

          if (code) {
            window.location.href = base + '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(base + target);
          } else {
            window.location.href = base + target;
          }
        })
        .catch(function (error) {
          button.removeAttribute('aria-busy');
          button.textContent = originalText;
          if (!errorEl) return;
          errorEl.hidden = false;

          if (window.Shopify && window.Shopify.designMode) {
            errorEl.textContent = 'Adding to cart does not work inside the theme editor. Open your live store to test it.';
            return;
          }

          errorEl.textContent = error && error.message
            ? error.message
            : (bundle.getAttribute('data-error-text') || 'Something went wrong. Please try again.');
        });
    }

    $$('[data-bundle-add]').forEach(function (button) {
      if (button.dataset.bundleBound === 'true') return;
      button.dataset.bundleBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart(button);
      });
    });

    var preselected = tiers.filter(function (tier) {
      var input = $('.bundle__radio-input', tier);
      return input && input.checked;
    })[0];

    selectTier(preselected || tiers[0]);
  }

  function init(root) {
    $$('[data-bundle]', root || document).forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
